import { FormField, FormRenderTypes } from "../Shared/Components/FormRenderer";
import { FormRenderGroupTypes } from "../Shared/Components/FormRenderer/FormRenderGroup.types";

export const regionFields: FormField[] = [
	{
		name: "name",
		label: "Nazwa regionu",
		type: FormRenderTypes.input,
		value: "",
		placeholder: "Nazwa regionu",
		group: FormRenderGroupTypes.basic,
	},
	{
		name: "description",
		label: "Opis regionu",
		type: FormRenderTypes.wysiwyg,
		value: "",
		placeholder: "Opis regionu",
		group: FormRenderGroupTypes.basic,
	},
	{
		name: "countryId",
		label: "Kraj",
		type: FormRenderTypes.autocomplete,
		value: "",
		placeholder: "Wybierz kraj",
		group: FormRenderGroupTypes.basic,
	},
];
